export default __webpack_public_path__ + "images/627a3c858c6a911395b605d29bedefaf.png";